import React, { lazy, Component } from 'react';
import { CheckIcon } from 'lucide-react';
// Componente de imagen con lazy loading
const LazyImage = ({
  src,
  alt,
  className
}) => {
  return <img src={src} alt={alt} className={className} loading="lazy" data-id="element-60" />;
};
export function CallToAction() {
  return <section className="py-16 bg-gradient-to-b from-amber-100 to-amber-200" data-id="element-61">
      <div className="container mx-auto px-4" data-id="element-62">
        <div className="max-w-3xl mx-auto text-center" data-id="element-63">
          <h2 className="text-3xl md:text-4xl font-bold text-amber-800 mb-6" data-id="element-64">
            Visualízate dentro de 7 días:
          </h2>
          <div className="flex flex-col md:flex-row justify-center gap-4 mb-8" data-id="element-65">
            <Benefit text="Tus cenas... rápidas." data-id="element-66" />
            <Benefit text="Tus hijos... felices." data-id="element-67" />
            <Benefit text="Tu rutina... ligera." data-id="element-68" />
          </div>
          <p className="text-amber-700 mb-8 max-w-xl mx-auto" data-id="element-69">
            Y tú... con tiempo extra para descansar, leer o simplemente
            disfrutar. Es hora de soltar la culpa. Es hora de recuperar tu paz
            en la cocina.
          </p>
          <div className="bg-white p-8 rounded-xl shadow-lg mb-8" data-id="element-70">
            <div className="flex items-center justify-center mb-6" data-id="element-71">
              <LazyImage src="https://uploadthingy.s3.us-west-1.amazonaws.com/7AY45gNhozvRTNbRSGzoFB/Generated_Image_September_11%2C_2025_-_5_32PM.png" alt="Libro de 20 Cenas Listas en 15 Minutos" className="w-48 rounded-md shadow-md" data-id="element-72" />
            </div>
            <h3 className="text-2xl font-bold text-amber-800 mb-4" data-id="element-73">
              20 Cenas Listas en 15 Minutos
            </h3>
            <p className="text-amber-700 mb-6" data-id="element-74">
              Recetas sin horno para mamás ocupadas
            </p>
            <div className="flex justify-center" data-id="element-75">
              <a href="https://productivetips.com/cart/45129127657658:1?checkout" className="bg-amber-700 hover:bg-amber-800 text-white font-bold py-3 px-8 rounded-lg shadow-md text-lg transition duration-300" data-id="element-76">
                Comprar ahora - Solo $9.97
              </a>
              <p className="mt-2 text-amber-700 text-sm font-medium" data-id="element-77">
                <span className="line-through" data-id="element-78">$29.91</span> • Ahorras $19.94
              </p>
            </div>
          </div>
          <p className="text-sm text-amber-700" data-id="element-79">
            *Recibirás tu ebook en formato PDF inmediatamente después de la
            compra.
          </p>
        </div>
      </div>
    </section>;
}
function Benefit({
  text
}) {
  return <div className="flex items-center justify-center space-x-2 bg-amber-50 py-2 px-4 rounded-full shadow-sm" data-id="element-80">
      <CheckIcon className="h-5 w-5 text-amber-600" data-id="element-81" />
      <span className="text-amber-800 font-medium" data-id="element-82">{text}</span>
    </div>;
}